import { motion } from 'framer-motion';
import { HORECA } from '@/constants/testIds';
import { PenLine, PackageOpen, FileText, Truck } from 'lucide-react';

const STEPS = [
  {
    n: '01',
    t: 'Talep',
    icon: PenLine,
    d: 'Formu doldurun; firma bilgileri, ilgilendiğiniz kategoriler ve hacmi paylaşın.',
    time: 'Sen',
  },
  {
    n: '02',
    t: 'Numune',
    icon: PackageOpen,
    d: 'Ekibimiz iletişime geçer, uygun görülen kurumsal talepler için numune hazırlanır.',
    time: '2-3 gün',
  },
  {
    n: '03',
    t: 'Teklif',
    icon: FileText,
    d: 'Hacminize, ambalaj ve teslimat sıklığınıza uygun kademeli fiyat teklifi.',
    time: '1 iş günü',
  },
  {
    n: '04',
    t: 'Sevkiyat',
    icon: Truck,
    d: 'Aylık planlı teslimat başlar; private label ve seasonal koleksiyonlarda sürekli destek.',
    time: '2-5 gün',
  },
];

export default function Process() {
  return (
    <section
      id="surec"
      data-testid={HORECA.processSection}
      className="relative paper-kraft text-[#1F1F1F] py-24 md:py-32 overflow-hidden"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 relative">
        <div className="grid lg:grid-cols-12 gap-8 lg:gap-12 mb-16">
          <div className="lg:col-span-7">
            <span className="eyebrow text-[#B03A2E] mb-4 block">Süreç</span>
            <h2 className="font-display text-4xl md:text-5xl lg:text-6xl leading-[1.05] tracking-tight font-light">
              4 adımda
              <span className="italic text-[#5D2A47]"> işbirliği</span>.
            </h2>
          </div>
          <p className="lg:col-span-5 lg:pt-4 text-[#5A5145] text-base md:text-lg leading-relaxed font-body font-light">
            Talepten teslimata net bir yolculuk. Şeffaf, öngörülebilir ve
            adım adım desteklenen bir süreç.
          </p>
        </div>

        <div className="relative">
          {/* Dashed line connecting steps */}
          <div
            className="hidden lg:block absolute top-[70px] left-[10%] right-[10%] h-px border-t border-dashed border-[#1F1F1F]/25"
            aria-hidden
          />

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 lg:gap-8 relative">
            {STEPS.map((s, i) => {
              const Icon = s.icon;
              return (
                <motion.div
                  key={s.n}
                  initial={{ opacity: 0, y: 24 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true, margin: '-60px' }}
                  transition={{ duration: 0.7, delay: i * 0.12, ease: [0.22, 1, 0.36, 1] }}
                  className="relative group"
                >
                  {/* Numbered circle badge */}
                  <div className="relative z-10 mb-6">
                    <div className="w-[80px] h-[80px] rounded-full bg-[#FBF7EE] border border-[#1F1F1F]/15 flex items-center justify-center relative group-hover:border-[#B03A2E] transition-colors">
                      <Icon
                        className="w-7 h-7 text-[#1F1F1F] group-hover:text-[#B03A2E] transition-colors"
                        strokeWidth={1.4}
                      />
                      <div className="absolute -top-2 -right-2 bg-[#1F1F1F] text-[#FBF7EE] w-9 h-9 rounded-full flex items-center justify-center font-display text-sm">
                        {s.n}
                      </div>
                    </div>
                  </div>

                  <div className="flex items-baseline gap-3 mb-2">
                    <h3 className="font-display text-2xl md:text-3xl leading-tight text-[#1F1F1F]">
                      {s.t}
                    </h3>
                    <span className="eyebrow text-[#B08834]">{s.time}</span>
                  </div>
                  <p className="text-sm md:text-base text-[#5A5145] leading-relaxed font-body font-light">
                    {s.d}
                  </p>
                </motion.div>
              );
            })}
          </div>
        </div>

        {/* CTA */}
        <div className="mt-16 flex flex-col md:flex-row items-start md:items-center gap-4 md:gap-8 pt-10 border-t border-[#1F1F1F]/15">
          <div className="flex-1">
            <div className="font-display text-2xl md:text-3xl text-[#1F1F1F] font-light">
              Ortalama işbirliği başlangıcı:
              <span className="italic text-[#B03A2E]"> 7-10 iş günü</span>.
            </div>
          </div>
          <a
            href="#iletisim"
            className="inline-flex items-center gap-3 bg-[#1F1F1F] hover:bg-[#B03A2E] text-[#FBF7EE] px-8 py-4 text-xs tracking-[0.2em] transition-colors font-body"
          >
            SÜRECİ BAŞLAT
          </a>
        </div>
      </div>
    </section>
  );
}
